import { persistSessionTokens, type SessionTokens } from '@/services/session';

// The auth feature's barrel also exports its screens; loading it on first use
// keeps them out of the signup pages' first load.
const authFeature = () => import('@/features/auth');

/**
 * Signs the member in with a session the seam returned, as the auth flow's own
 * sign-in does: the tokens are persisted, then the session is identified for
 * analytics in the background, which never delays or fails the sign-in.
 */
export function signInWithSession(tokens: SessionTokens): void {
  persistSessionTokens(tokens);
  void authFeature()
    .then((auth) => auth.identifyAnalyticsSession())
    .catch(() => undefined);
}
